import { createFileRoute } from "@tanstack/react-router";
import { SpringRegisterEnrollPage } from "@pages/spring-register-enroll-page";

export const Route = createFileRoute("/spring-health/register/enroll")({
  component: SpringRegisterEnrollPage,
});
